module.exports = "/images/img_guide02.png?45165877c63178e342c00bd925a89695";